<template>
  <div class="col-lg-2 col-md-4">
    <div class="footer-title">
      <h5>
        {{ _T('Pages') }}
        <span class="according-menu">
          <svg width="12" height="6" fill="none">
            <use xlink:href="#downArrow" />
          </svg>
        </span>
      </h5>
    </div>
    <ul class="footer-content">
      <li class="nav-item" v-for="(page, pIndex) of all_static_pages.filter(e=>e.shown_menu && !['about','faq','contact-us','terms-condition','privacy-policy','how-it-works'].includes(e.slug))" :key="pIndex">
          <router-link :to="{ name: 'to_page',params :{page_slug: page.slug} }" class="nav-link">
            {{ _T(page.page_title) }}
          </router-link>

        </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand','all_static_pages']),
  },
}
</script>
